import React from 'react';

import {
	ContextualInviteNudgeFlagLoadable,
	LIVE_PAGE_SOURCE,
} from '@confluence/contextual-invite-nudge-flag';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';
import { UNSAFE_isExperimentEnabledNoExposure } from '@confluence/feature-experiments';

import { useLivePageInviteNudgeStore } from './useLivePageInviteNudgeStore.tsx';

const LivePageInviteNudgeComponent = () => {
	const [{ hasLivePageChanges }] = useLivePageInviteNudgeStore();

	if (
		!hasLivePageChanges ||
		UNSAFE_isExperimentEnabledNoExposure('twcg-2055-confluence-onboarding-flag-to-share')
	) {
		return null;
	}

	return <ContextualInviteNudgeFlagLoadable source={LIVE_PAGE_SOURCE} />;
};

export const LivePageInviteNudge: React.FC<{}> = withTransparentErrorBoundary({
	attribution: Attribution.CE_MAU,
})(LivePageInviteNudgeComponent);
